<template>
  <Card class="layout-card" >
    <Form label-position="top" :model="searchForm">
      <Row :gutter="10">
        <Col :span="4">
          <FormItem>
            <Select  clearable filterable v-model="searchForm.minisReleaseAppList" multiple placeholder="请选择小程序">
              <Option
                v-for="item in minisPlayOptions"
                :key="item.id"
                :value="item.id"
                :label="item.minisName"
              />
            </Select>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Select clearable filterable v-model="searchForm.langIdList" @on-change="getTagListFn" multiple placeholder="请选择语言">
              <Option
                v-for="item in languageOptions"
                :key="item.id"
                :value="item.id"
                :label="item.chineseLangName||item.langName"
              />
            </Select>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Select clearable v-model="searchForm.minisPlayRelease" placeholder="请选择发布状态">
              <Option :value="1" label="已发布" />
              <Option :value="0" label="未发布" />
            </Select>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Input v-model="searchForm.playName" placeholder="请输入中文剧集名称" clearable/>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Input v-model="searchForm.id" placeholder="请输入剧集ID" clearable/>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
             <Cascader
              :data="playType"
              v-model="searchForm.productionType"
              placeholder="请选择剧类型"
            ></Cascader>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="10">
        <Col :span="4">
          <FormItem>
            <Select clearable multiple v-model="searchForm.playTagList" :disabled="searchForm.langIdList.length === 0" placeholder="请选择标签">
              <Option  v-for="item in tagOptions" :key="item.id" :value="item.id">
                {{ item.tagChineseName }}({{ item.tagName }})
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col :span="8">
          <FormItem>
            <Button type="primary" icon="ios-search" @click="handleGetData(1)">搜索</Button>
            <Button @click="handleReset" style="margin-left: 10px">重置</Button>
            <Button
              type="warning"
              :loading="externalUpdateLoading"
              :disabled="selectedPlayIds.length === 0"
              @click="handleBatchExternalRelease"
              style="margin-left: 10px"
            >公开到外部查询</Button>
          </FormItem>
        </Col>
      </Row>
    </Form>

    <Table
      :data="tableData"
      :columns="columns"
      :loading="loading"
      style="margin-top: 10px"
      @on-selection-change="handleSelectionChange"
    >
      <template #tagSlot="{ row }">
          <div style="display: flex; flex-wrap: wrap; gap: 4px;" v-if="row.tagName">
            <span
              v-for="(tag,index) in row.tagName.split('、')"
              :key="index"
              :style="{
                 backgroundColor: 'rgb(236, 245, 255)',
                 border: '1px solid rgb(160, 207, 255)',
                color: '#409eff',
                padding: '2px 8px',
                borderRadius: '4px',
                fontSize: '12px'
              }"
            >
              {{ tag }}
            </span>
          </div>
          
      </template>

      <template #statusSlot="{ row }">
        <div>
          <div :style="getReleaseStatusBadgeStyle(row.minisPlayRelease)">
            {{ getReleaseStatusText(row) }}
          </div>
          <div
            v-if="shouldShowReleaseTime(row)"
            style="font-size: 11px; color: #999; margin-top: 4px;"
          >
            <template v-if="Number(row.minisPlayRelease) === 1">初次发布: </template>{{ formatReleaseDisplayTime(row.minisPlayReleaseTime) }}
          </div>
        </div>
      </template>
      <template #episodeCount="{ row }">
        {{ (row.releaseTotal || 0) + '/' + (row.playTotal || 0) }}
      </template>
      <template #onlineAtSlot="{ row }">
        {{ formatOnlineAt(row.onlineAt) }}
      </template>
      <template #fileUrl="{ row }">
        <div>
          <img
            v-if="row.fileUrl"
            :src="row.fileUrl"
            alt="封面"
            style="width: 60px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer"
            @click="$viewerApi({ images: [row.fileUrl] })"
          />
          <span
            v-else
            style="display: flex; align-items: center; justify-content: center; width: 60px; height: 80px; background-color: #f5f5f5; border-radius: 4px; font-size: 12px; color: #999;"
          >
            封面
          </span>
        </div>
      </template>

      <template #actionSlot="{ row }">
        <div>
          <a style="color: #2d8cf0; margin-right: 10px" @click="handleEdit(row)">编辑</a>
          <a style="color: #2d8cf0" @click="handlePreview(row)">在线预览</a>
        </div>
      </template>

      <template #footer>
        <Pages :page="page" :func="handleGetData"  />
      </template>
    </Table>

    <Modal
      v-model="dialogVisible"
      :title="  editForm.chineseName ? '编辑剧集：' + editForm.chineseName : '编辑剧集' "
      class-name="short-video-edit-modal"
      width="520"
    >
      <Spin v-if="editDetailLoading" fix />
      <Form :label-width="100" :model="editForm" ref="editFormRef" :rules="editRules" class="short-video-edit-form">
        <FormItem label="剧集发布状态">
          <i-switch
            v-model="editForm.minisPlayRelease"
            :true-value="1"
            :false-value="0"
            @on-change="handleStatusChange"
            class="release-status-switch"
          >
            <span slot="open">已发布</span>
            <span slot="close">未发布</span>
          </i-switch>
        </FormItem>
        <template v-if="editForm.minisPlayRelease === 1">
          <FormItem label="发布小程序" prop="minisReleaseAppList">
            <RadioGroup
              v-model="editForm.minisAppMode"
              type="button"
              button-style="solid"
              class="edit-segment-group minis-app-segment-group"
              @on-change="handleMinisAppModeChange"
            >
              <Radio label="all">全部小程序</Radio>
              <Radio label="custom">自定义</Radio>
            </RadioGroup>
            <div v-if="editForm.minisAppMode === 'custom'" class="minis-app-custom-panel">
              <a class="minis-select-toggle" @click="handleToggleMinisSelectAll">
                {{ isAllMinisSelected ? '取消全选' : '全选' }}
              </a>
              <div class="minis-checkbox-scroll" @scroll="handleMinisCheckboxScroll">
                <CheckboxGroup
                  v-model="editForm.minisReleaseAppList"
                  class="minis-checkbox-grid"
                  @on-change="handleMinisReleaseAppListChange"
                >
                  <Checkbox
                    v-for="app in editMinisPlayOptions"
                    :key="app.id"
                    :label="app.id"
                  >
                    {{ app.minisName }}
                  </Checkbox>
                </CheckboxGroup>
              </div>
            </div>
          </FormItem>
          <FormItem label="发布时间">
            <RadioGroup
              v-model="editForm.publishTimeType"
              type="button"
              button-style="solid"
              class="edit-segment-group"
            >
              <Radio label="immediate">立即发布</Radio>
              <Radio label="scheduled">定时发布</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem
            v-if="editForm.publishTimeType === 'scheduled'"
            label="北京时间"
            prop="scheduledTime"
          >
            <DatePicker
              v-model="editForm.scheduledTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择发布时间"
              class="scheduled-time-picker"
            />
          </FormItem>
        </template>
      </Form>
      <template #footer>
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" :loading="editSaveLoading" :disabled="editDetailLoading" @click="handleSave">保存</Button>
      </template>
    </Modal>
    <!-- <VideoPreview
      :visible.sync="previewVisible"
      :row="previewRow"
      @close="previewVisible = false"
    /> -->
    <seriesPlay :data="seriesData" ref="seriesPlayRef" />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import VideoPreview from './video-preview.vue'
import dayjs from 'dayjs'
import { getPlayList, getMinisPlayList, editPlay, getPlayPublishDetail, getSeriesByPlayId, batchUpdateExternalRelease } from '@/api/short-video'
import seriesPlay from '../play/series-play.vue'
import { getTagList } from '../../api/tag'
import { getLangList } from '../../api/lang'
import { getSeriesPreview } from '@/api/play'
import { playType } from '@/libs/dictionary'

/** 上线时间排序用：统一转为毫秒时间戳 */
function onlineAtToSortMs(value) {
  if (value == null || value === '') {
    return 0
  }
  if (typeof value === 'string' && /^\d+$/.test(value)) {
    return onlineAtToSortMs(Number(value))
  }
  if (typeof value === 'number') {
    return value > 9999999999 ? value : value * 1000
  }
  const parsed = dayjs(value)
  return parsed.isValid() ? parsed.valueOf() : 0
}

export default {
  name: 'ShortVideoList',
  components: {
    Pages,
    VideoPreview,
    seriesPlay
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      editDetailLoading: false,
      editSaveLoading: false,
      editCustomMinisIds: [],
      previewVisible: false,
      previewRow: {},
      externalUpdateLoading: false,
      selectedPlayIds: [],
      editFormRef: null,
      minisCheckboxScrollTimer: null,
      playType,
      languageOptions: [],// 语言列表
      tagOptions: [], // 标签列表
      seriesData: {}, // 短剧剧集数据
      minisPlayOptions: [], // 小程序列表
      searchForm: {
        minisReleaseAppList: [],
        langIdList: [],
        minisPlayRelease: null,
        playName: '',
        id: '',
        productionType: [],
        playTagList: []
      },
      editForm: {
        id: '',
        chineseName: '',
        minisPlayRelease: null,
        minisReleaseAppList: [],
        minisAppMode: 'all',
        publishTimeType: 'immediate',
        scheduledTime: null,
        episodeCount: ''
      },
      editRules: {
        minisReleaseAppList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                this.editForm.minisPlayRelease === 1 &&
                this.editForm.minisAppMode === 'custom' &&
                (!value || value.length === 0)
              ) {
                callback(new Error('请选择发布小程序'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        scheduledTime: [
          {
            validator: (rule, value, callback) => {
              if (
                this.editForm.minisPlayRelease === 1 &&
                this.editForm.publishTimeType === 'scheduled' &&
                !value
              ) {
                callback(new Error('请选择发布时间'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      tableData: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '剧集ID',
          key: 'id',
          width: 100,
          sortable: true
        },
        {
          title: '短剧名称',
          key: 'playName',
          minWidth: 80
        },
        {
          title: '中文名称',
          key: 'chineseName',
          minWidth: 80
        },
        {
          title: '封面',
          key: 'fileUrl',
          width: 100,
          slot: 'fileUrl'
        },
        {
          title: '语言',
          key: 'langName',
          width: 80
        },
        {
          title: '集数',
          key: 'episodeCount',
          width: 80,
          sortable: true,
          slot: 'episodeCount'
        },
        {
          title: '上线时间',
          key: 'onlineAt',
          width: 168,
          sortable: true,
          slot: 'onlineAtSlot',
          sortMethod(a, b, type) {
            const diff = onlineAtToSortMs(a) - onlineAtToSortMs(b)
            return type === 'asc' ? diff : -diff
          }
        },
        {
          title: '发布状态',
          key: 'minisPlayRelease',
          width: 130,
          slot: 'statusSlot'
        },
        {
          title: '已发布小程序',
          key: 'boundMinisNames',
          minWidth: 80
        },
        {
          title: '剧类型',
          key: 'productionType',
          width: 130,
          tooltip: true
        },
        {
          title: '标签',
          key: 'tagName',
          minWidth: 100,
          slot: 'tagSlot'
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          slot: 'actionSlot'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      
    }
  },
  computed: {
    editMinisPlayOptions() {
      return this.minisPlayOptions.filter(app => Number(app.isOwn) === 1)
    },
    isAllMinisSelected() {
      const allIds = this.editMinisPlayOptions.map(app => app.id)
      const selectedIds = this.editForm.minisReleaseAppList || []
      return allIds.length > 0 && allIds.every(id => selectedIds.includes(id))
    }
  },
  mounted() {
    this.handleGetData()
    this.getLanguageList()
    // this.getTagListFn()
    this.getMinisPlayListFn()
  },
  beforeDestroy() {
    if (this.minisCheckboxScrollTimer) {
      clearTimeout(this.minisCheckboxScrollTimer)
    }
  },
  methods: {
    handleGetData(current) {
      this.loading = true
      if (current) this.page.current = current
      else this.page.current = 1
      const params = {
        ...this.searchForm,
      }
     for(let key in params){
      if( Array.isArray(params[key])&&key=='productionType'){
        params[key] = params[key].join('-')
      }else if( Array.isArray(params[key])){
        params[key] = params[key].join(',')
      }
      if(params[key] === ''){
        delete params[key]
      }
     }
      getPlayList({
        current: this.page.current,
        size: this.page.size,
        ...params
      }).then(res => {
        if (res.code === 200) {
          this.tableData = this.formatTableData(res.data.records)
          this.page.total = res.data.total
          this.loading = false
        }
      })
     
    },
    // 获取语言列表
    getLanguageList() {
      getLangList({ current: -1, size: -1 }).then((r) => {
        if (r.code === 200) {
          this.languageOptions = r.data.records
        }
      })
    },
    // 获取标签列表
    getTagListFn() {
      if(this.searchForm.langIdList.length === 0){
        return
      }
      getTagList({ current: -1, size: -1, tagStatus: true, langIdList: this.searchForm.langIdList.join(',') }).then(res => {
        if (res.code === 200) {
          this.tagOptions = res.data.records
        }
      })
    },
    normalizeMinisPlayOptions(list) {
      const records = Array.isArray(list) ? list : (list && list.records) || []
      return records.map(item => ({
        ...item,
        id: Number(item.minisId != null ? item.minisId : item.id),
        isOwn: Number(item.isOwn != null ? item.isOwn : 0)
      })).filter(item => !isNaN(item.id))
    },
    toMinisIdList(ids) {
      const optionIdSet = new Set(this.editMinisPlayOptions.map(app => app.id))
      return (ids || [])
        .map(id => Number(id))
        .filter(id => optionIdSet.has(id))
    },
    // 获取小程序列表
    getMinisPlayListFn() {
      return getMinisPlayList().then((r) => {
        if (r.code === 200) {
          this.minisPlayOptions = this.normalizeMinisPlayOptions(r.data)
        }
        return this.minisPlayOptions
      })
    },
    isSelectionDisabled(row) {
      return Number(row.externalRelease) === 1
    },
    formatTableData(records) {
      const rows = records || []
      const selectedIdSet = new Set(this.selectedPlayIds.map(id => String(id)))
      const disabledIdSet = new Set(
        rows
          .filter(row => this.isSelectionDisabled(row))
          .map(row => String(row.id))
      )

      if (disabledIdSet.size) {
        this.selectedPlayIds = this.selectedPlayIds.filter(id => !disabledIdSet.has(String(id)))
      }

      return rows.map(row => ({
        ...row,
        _checked: !this.isSelectionDisabled(row) && selectedIdSet.has(String(row.id)),
        _disabled: this.isSelectionDisabled(row)
      }))
    },
    handleSelectionChange(selection) {
      const currentSelectableIdSet = new Set(
        this.tableData
          .filter(row => !this.isSelectionDisabled(row))
          .map(row => String(row.id))
      )
      const nextSelectedMap = new Map()

      this.selectedPlayIds.forEach(id => {
        if (!currentSelectableIdSet.has(String(id))) {
          nextSelectedMap.set(String(id), id)
        }
      })
      selection.forEach(row => {
        if (!this.isSelectionDisabled(row)) {
          nextSelectedMap.set(String(row.id), row.id)
        }
      })

      this.selectedPlayIds = Array.from(nextSelectedMap.values())
    },
    handleBatchExternalRelease() {
      if (!this.selectedPlayIds.length) return
      const playIds = [...this.selectedPlayIds]
      this.$Modal.confirm({
        title: '提示',
        content: `确定将已选 ${playIds.length} 部短剧公开到外部查询吗？`,
        okText: '确定',
        cancelText: '取消',
        type: 'warning',
        onOk: () => {
          this.submitBatchExternalRelease(playIds)
        }
      })
    },
    submitBatchExternalRelease(playIds) {
      this.externalUpdateLoading = true
      batchUpdateExternalRelease({
        externalRelease: 1,
        playIds
      }).then(res => {
        if (res.code === 200) {
          this.$Message.success('操作成功')
          this.selectedPlayIds = []
          this.handleGetData(this.page.current)
        }
      }).finally(() => {
        this.externalUpdateLoading = false
      })
    },
    handleReset() {
      this.searchForm = {
        minisReleaseAppList: [],
        langIdList: [],
        minisPlayRelease: null,
        playName: '',
        id: '',
        productionType: [],
        playTagList: []
      }
      this.handleGetData(1)
    },
    handleMinisAppModeChange(mode) {
      if (mode === 'custom') {
        this.editForm.minisReleaseAppList = [...this.editCustomMinisIds]
      }
      this.validateEditField('minisReleaseAppList')
    },
    handleMinisReleaseAppListChange(list) {
      this.editCustomMinisIds = [...list]
    },
    handleToggleMinisSelectAll() {
      if (this.isAllMinisSelected) {
        this.editForm.minisReleaseAppList = []
      } else {
        this.editForm.minisReleaseAppList = this.editMinisPlayOptions.map(app => app.id)
      }
      this.editCustomMinisIds = [...this.editForm.minisReleaseAppList]
      this.validateEditField('minisReleaseAppList')
    },
    validateEditField(prop) {
      const form = this.$refs.editFormRef
      if (!form || !form.fields) {
        return
      }
      const hasField = form.fields.some(field => field.prop === prop)
      if (hasField) {
        form.validateField(prop)
      }
    },
    handleMinisCheckboxScroll(e) {
      const el = e.target
      el.classList.add('is-scrolling')
      if (this.minisCheckboxScrollTimer) {
        clearTimeout(this.minisCheckboxScrollTimer)
      }
      this.minisCheckboxScrollTimer = setTimeout(() => {
        el.classList.remove('is-scrolling')
      }, 800)
    },
    getMinisReleaseAppListForSave() {
      if (this.editForm.minisAppMode === 'all') {
        return this.editMinisPlayOptions.map(app => String(app.id))
      }
      return this.editForm.minisReleaseAppList.map(id => String(id))
    },
    formatPublishTime(time) {
      return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    /** 列表「上线时间」展示（接口 onlineAt） */
    formatOnlineAt(time) {
      if (time == null || time === '') {
        return '—'
      }
      if (typeof time === 'string' && /^\d+$/.test(time)) {
        return this.formatOnlineAt(Number(time))
      }
      if (typeof time === 'number') {
        const ms = time > 9999999999 ? time : time * 1000
        const parsed = dayjs(ms)
        return parsed.isValid() ? parsed.format('YYYY/MM/DD HH:mm') : '—'
      }
      const parsed = dayjs(time)
      return parsed.isValid() ? parsed.format('YYYY/MM/DD HH:mm') : '—'
    },
    formatReleaseDisplayTime(time) {
      if (time == null || time === '') {
        return ''
      }
      if (typeof time === 'string' && /^\d+$/.test(time)) {
        return this.formatReleaseDisplayTime(Number(time))
      }
      if (typeof time === 'number') {
        const ms = time > 9999999999 ? time : time * 1000
        return dayjs(ms).format('YYYY-MM-DD HH:mm:ss')
      }
      return time
    },
    getReleaseStatusText(row) {
      if (row.minisPlayReleaseDesc) {
        return row.minisPlayReleaseDesc
      }
      const statusMap = {
        0: '未发布',
        1: '已发布',
        2: '定时发布'
      }
      return statusMap[Number(row.minisPlayRelease)] || '未发布'
    },
    getReleaseStatusBadgeStyle(status) {
      const styleMap = {
        0: {
          backgroundColor: '#fdf6ec',
          color: '#e6a23c',
          borderColor: '#e6a23c'
        },
        1: {
          backgroundColor: '#f0f9e8',
          color: '#67c23a',
          borderColor: '#67c23a'
        },
        2: {
          backgroundColor: '#f9f0ff',
          color: '#722ed1',
          borderColor: '#722ed1'
        }
      }
      const currentStyle = styleMap[Number(status)] || styleMap[0]
      return {
        display: 'inline-block',
        padding: '3px 10px',
        borderRadius: '4px',
        backgroundColor: currentStyle.backgroundColor,
        color: currentStyle.color,
        border: '1px solid',
        borderColor: currentStyle.borderColor
      }
    },
    shouldShowReleaseTime(row) {
      const status = Number(row.minisPlayRelease)
      return (status === 1 || status === 2) && row.minisPlayReleaseTime
    },
    getEchoPublishTime(detail) {
      if (detail.echoPublishTime != null && detail.echoPublishTime !== '') {
        return detail.echoPublishTime
      }
      if (detail.scheduledReleaseInfo && detail.scheduledReleaseInfo.releaseTime) {
        return detail.scheduledReleaseInfo.releaseTime
      }
      return null
    },
    parsePublishTimeForPicker(time) {
      if (time == null || time === '') {
        return null
      }
      if (typeof time === 'string' && /^\d+$/.test(time)) {
        return this.parsePublishTimeForPicker(Number(time))
      }
      if (typeof time === 'number') {
        const ms = time > 9999999999 ? time : time * 1000
        const parsed = dayjs(ms)
        return parsed.isValid() ? parsed.toDate() : null
      }
      const parsed = dayjs(time)
      return parsed.isValid() ? parsed.toDate() : null
    },
    fillEditFormFromDetail(detail, row) {
      const echoScopeType = detail.echoMinisScopeType
      const isAllMode = Number(echoScopeType) === 1
      const selectedIds = this.toMinisIdList(detail.echoSelectedMinisIds)

      this.editCustomMinisIds = [...selectedIds]
      this.editForm.id = detail.playId || row.id
      this.editForm.chineseName = row.chineseName
      this.editForm.minisPlayRelease = detail.echoReleaseSwitch != null
        ? detail.echoReleaseSwitch
        : row.minisPlayRelease
      this.editForm.minisAppMode = isAllMode ? 'all' : 'custom'
      this.editForm.minisReleaseAppList = isAllMode ? [] : [...selectedIds]
      this.editForm.publishTimeType = detail.echoPublishType === 2 ? 'scheduled' : 'immediate'
      this.editForm.episodeCount = row.episodeCount

      const echoPublishTime = this.getEchoPublishTime(detail)
      const scheduledTime = this.parsePublishTimeForPicker(echoPublishTime)
      this.editForm.scheduledTime = scheduledTime

      if (this.editForm.minisPlayRelease === 1) {
        this.$nextTick(() => {
          if (!isAllMode) {
            this.editForm.minisReleaseAppList = [...selectedIds]
          }
          if (this.editForm.publishTimeType === 'scheduled') {
            this.editForm.scheduledTime = this.parsePublishTimeForPicker(echoPublishTime)
          }
        })
      }
    },
    buildEditPlayPayload() {
      const payload = {
        id: this.editForm.id,
        minisPlayRelease: this.editForm.minisPlayRelease
      }
      if (this.editForm.minisPlayRelease === 1) {
        payload.minisReleaseAppList = this.getMinisReleaseAppListForSave()
        payload.publishType = this.editForm.publishTimeType === 'scheduled' ? 2 : 1
        if (payload.publishType === 2) {
          payload.publishTime = this.formatPublishTime(this.editForm.scheduledTime)
        }
      }
      return payload
    },
    resetEditForm() {
      this.editCustomMinisIds = []
      this.editForm = {
        id: '',
        chineseName: '',
        minisPlayRelease: null,
        minisReleaseAppList: [],
        minisAppMode: 'all',
        publishTimeType: 'immediate',
        scheduledTime: null,
        episodeCount: ''
      }
    },
    handleStatusChange(value) {
      console.log(value);
      if (value ==0) {
        getSeriesByPlayId({
          playId: this.editForm.id
        }).then(res => {
          if (res.code === 200) {
            if(res.data){
              // 是否确认取消发布
             this.$Modal.confirm({
               title: '提示',
               content: '当前这部剧已经被添加至剧场首页,取消发布后将从剧场配置中删除,是否确认？',
                onOk: () => {
                   this.editForm.minisPlayRelease = 0
                  this.editForm.minisReleaseAppList = []
                  this.editCustomMinisIds = []
                  this.validateEditField('minisReleaseAppList')
                },
                onCancel: () => {
                  this.editForm.minisPlayRelease = 1
                },
                okText: '确定',
                cancelText: '取消',
                type: 'warning'
              })
            }
          }
        })
       
      }
    },
    handleEdit(row) {
      this.resetEditForm()
      this.editForm.id = row.id
      this.editForm.chineseName = row.chineseName
      this.dialogVisible = true
      this.editDetailLoading = true
      const minisListPromise = this.minisPlayOptions.length
        ? Promise.resolve(this.minisPlayOptions)
        : this.getMinisPlayListFn()
      minisListPromise.then(() => {
        return getPlayPublishDetail({ playId: row.id })
      }).then(res => {
        if (res.code === 200) {
          this.fillEditFormFromDetail(res.data || {}, row)
        }
      }).catch(() => {
        this.$Message.error('获取发布详情失败')
        this.dialogVisible = false
      }).finally(() => {
        this.editDetailLoading = false
      })
    },
    handleCancel() {
      this.dialogVisible = false
      this.resetEditForm()
      if (this.$refs.editFormRef) {
        this.$refs.editFormRef.resetFields()
      }
    },
    handleSave() {
        this.$refs.editFormRef.validate(valid => {
          if (valid) {
            this.editSaveLoading = true
            editPlay(this.buildEditPlayPayload()).then(res => {
              if (res.code === 200) {
                this.$Message.success('保存成功')
                this.handleGetData(this.page.current)
                this.dialogVisible = false
                this.resetEditForm()
                this.$refs.editFormRef.resetFields()
              }
            }).finally(() => {
              this.editSaveLoading = false
            })
          }
        })
    },
    handlePreview(row) {
      getSeriesPreview({
        current: 1,
        size: 500,
        playId: row.id
      }).then((r) => {
        this.seriesData = r.data
        if (r.data.seriesList.length)
          this.$nextTick(() => {
            this.$refs.seriesPlayRef.visible = true
          })
        else this.$Message.error('该短剧无可预览剧集')
      })
      // this.previewRow = { ...row }
      // this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.short-video-edit-form {
  padding-right: 4px;
}

.short-video-edit-form >>> .ivu-form-item {
  margin-bottom: 18px;
}

.release-status-switch {
  width: 65px;
}

.edit-segment-group {
  display: inline-flex;
}

.edit-segment-group >>> .ivu-radio-wrapper {
  flex: none;
  min-width: auto;
  padding: 0 14px;
  text-align: center;
}

.minis-app-segment-group >>> .ivu-radio-wrapper {
  width: 108px;
  padding: 0;
}

.minis-app-custom-panel {
  margin-top: 8px;
}

.minis-select-toggle {
  color: #2d8cf0;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
}

.minis-checkbox-scroll {
  max-width: 360px;
  max-height: 128px;
  margin-top: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.minis-checkbox-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.minis-checkbox-scroll:hover,
.minis-checkbox-scroll.is-scrolling {
  scrollbar-width: thin;
}

.minis-checkbox-scroll:hover::-webkit-scrollbar,
.minis-checkbox-scroll.is-scrolling::-webkit-scrollbar {
  width: 6px;
}

.minis-checkbox-scroll:hover::-webkit-scrollbar-thumb,
.minis-checkbox-scroll.is-scrolling::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.minis-checkbox-scroll:hover::-webkit-scrollbar-track,
.minis-checkbox-scroll.is-scrolling::-webkit-scrollbar-track {
  background-color: transparent;
}

.minis-checkbox-grid {
  display: flex !important;
  flex-wrap: wrap;
  gap: 6px 0;
}

.minis-checkbox-grid >>> .ivu-checkbox-group-item,
.minis-checkbox-grid >>> .ivu-checkbox-wrapper {
  width: 33.33%;
  margin-right: 0;
  font-size: 13px;
  line-height: 26px;
}

.scheduled-time-picker {
  width: 280px;
}
</style>

<style>
.short-video-edit-modal .ivu-modal-body {
  padding: 16px 20px 8px;
}

.short-video-edit-modal .ivu-switch-checked:after {
  left: 44px;
}
</style>
